module.exports = __webpack_public_path__ + "static/media/31-f-piano.008113a3.svg";